import styled from 'styled-components';

// Components
import InputText from '../../inputs/InputText';
import { Label } from '../../inputs/InputText/styles';
import {
  InputContainer,
  InputValue,
  Container as ContainerInputText,
} from '../../inputs/InputText/styles';
import { InputTextArea } from '../../inputs/InputTextArea';
import { Area, Container } from '../../inputs/InputTextArea/styles';
import { Typography } from '../Typography';
import DoubleSwitch from '../../inputs/buttons/SwitchButton/Double';
import { Container as ContainerSwitch } from '../../inputs/buttons/SwitchButton/Double/styles';
import { RightArrowProps } from './types';

// Types

export const ContainerOT = styled.div`
  max-width: 89%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.greyClear};
  border-radius: 8px;
  padding: ${({ theme }) => theme.spacing.xl};

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: 87%;
    padding: ${({ theme }) => theme.spacing.l};
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    max-width: 100%;
  }
`;

export const ContainerHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.m};
  cursor: pointer;
`;

export const TitleOrder = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.L};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.M};
  }
`;

export const TitleDate = styled.span`
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    display: block;
    font-size: ${({ theme }) => theme.fontSize.S};
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  /* flex-wrap (2026-07-07): RouteSegmentOT ahora puede sumar hasta 3 chips
     (causa + resolt/pendent + estado) a este grupo — sin wrap desbordaba en
     viewports estrechos. No-op para el resto de ShowOT (1-2 chips, cabe en
     una línea). */
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xs};
  /* Los chips se alinean a la DERECHA — coherente con el ContainerRefIcon —
     para que la 2ª fila envuelta no quede descolgada a la izquierda. Feedback
     usuario 2026-07-31 para tablet; desde el 2026-09-24 en TODOS los anchos:
     entre 1024 y ~1920 px el grupo también se parte en filas y las de abajo
     se iban a la izquierda. En una sola fila no cambia nada (el grupo mide lo
     que sus chips). Aplica a TODAS las cards ShowOT. */
  justify-content: flex-end;
`;

export const ContainerRefIcon = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    /* Vertical: el cluster ROID + chips va pegado a la DERECHA (junto a la
       flecha), no centrado — feedback usuario 2026-07-31. Aplica a TODAS las
       cards ShowOT (WorkOrder/Action/Accident/Communication/SubWorkOrder/Tramo). */
    align-items: flex-end;
    gap: ${({ theme }) => theme.spacing.xxxs};
  }
`;

export const ContainerTitleArrow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const RefRoid = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSize.S};
`;

export const RightArrow = styled.img<RightArrowProps>`
  transform: ${({ showInfo }) => (showInfo ? `rotate(90deg)` : null)};
  width: 1.4rem;
  height: 1rem;
`;

export const ContainerContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: ${({ theme }) => theme.spacing.l};
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spacing.m};
  }
`;

export const DateContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const ContainerData = styled.div`
  display: flex;
  margin-top: 3.2rem;
  gap: ${({ theme }) => theme.spacing.l};
  flex-wrap: wrap;
  width: 100%;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spacing.m};
    margin-top: ${({ theme }) => theme.spacing.m};
  }
`;

export const ActionLocationGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.l};
  flex-wrap: wrap;
  align-items: flex-start;
  flex: 1 1 45%;

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    width: 100%;
  }

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spacing.m};
  }
`;

export const ContainerDescription = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  gap: 2.9rem;

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 2.2rem;
  }
`;

export const InputDescription = styled(InputTextArea)`
  &${Container} {
    width: 100%;
    min-height: 21rem;
  }
  ${Area} {
    background-color: ${(props) =>
    props.disabled ? props.theme.colors.greyLight : props.theme.colors.white};
    border: ${({ disabled }) => (disabled ? `none` : null)};
    color: ${(props) =>
    props.disabled
      ? props.theme.colors.greyVeryDark
      : props.theme.colors.black};
    width: 100%;
    min-height: 21rem;

    @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
      max-width: 74.325rem;
      height: 21rem;
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
    @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
      max-width: 46.8rem;
      height: 21rem;
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
  }
`;

export const InputOperaris = styled(InputText)`
  &${ContainerInputText} {
    max-width: 45rem;
    flex: 1 1 30rem;
  }
  ${InputContainer} {
    max-width: 45rem;
    padding: 0.7rem 1.4rem;
  }

  ${InputValue} {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    ${InputValue} {
      max-width: 36rem;
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
    ${Label} {
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
  }

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    ${InputValue} {
      max-width: 35rem;
    }
    &${ContainerInputText} {
      max-width: 35rem;
    }
    ${InputContainer} {
      max-width: 35rem;
    }
  }
`;

export const InputAction = styled(InputText)`
  &${ContainerInputText} {
    max-width: 25rem;
    flex: 1 1 20rem;
  }
  ${InputContainer} {
    max-width: 25rem;
    padding: 0.7rem 1.4rem;
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    ${InputValue} {
      max-width: 36rem;
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
    ${Label} {
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
  }

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    ${InputValue} {
      max-width: 30rem;
    }
    &${ContainerInputText} {
      max-width: 30rem;
    }
    ${InputContainer} {
      max-width: 30rem;
    }
  }
`;

export const SwitchButton = styled(DoubleSwitch)`
  &${ContainerSwitch} {
    min-width: 9.7rem;
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    &${ContainerSwitch} {
      min-width: 8.5rem;
    }
  }
`;

/**
 * Lista «una fila por carretera» de un recorrido o un tramo que pasa por varias
 * (multi-carretera 2026-08-18).
 *
 * 🔴 No es un `InputAction` porque la línea `C-25 (234+000 → 234+100), C-25z (…)`
 * NO CABE en una caja de ancho fijo — se veía cortada a la mitad. Y ponerla junto
 * a «Pk Inicial»/«Pk Final» repetía los mismos números dos veces.
 *
 * Pero SÍ copia sus tokens, uno a uno, porque la primera versión se veía como
 * algo ajeno a la tarjeta: la etiqueta salía gris claro entre etiquetas negras,
 * y cada fila se dimensionaba con su contenido, así que quedaban de anchos
 * distintos y más bajas que las cajas de al lado.
 *
 * De `InputText`/`InputAction`: etiqueta negra tamaño S (XS en tablet), caja de
 * alto `buttonHeight`, `borderRadius.md`, fondo `greyLight` —el del input
 * deshabilitado, que es lo que son estos datos— y el mismo `max-width` de 25rem.
 */
export const RoadStretchList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  /* Se ajusta a su contenido y puede encogerse: con un ancho de partida fijo,
     la fila más larga se salía de la tarjeta en pantallas estrechas. */
  flex: 0 1 auto;
  min-width: 0;
  max-width: 100%;
`;
/**
 * Las vías, UNA AL LADO DE OTRA.
 *
 * Apiladas crecían hacia abajo y estiraban la fila entera de campos, dejando
 * huecos muertos al lado de los que solo ocupan una línea. En horizontal el
 * bloque crece a lo ancho, que es por donde sobra sitio, y solo baja de línea
 * cuando de verdad no cabe.
 */
export const RoadStretchRows = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem 1.2rem;
  min-width: 0;
`;

export const RoadStretchLabel = styled(Typography).attrs({
  component: 'span',
  colorText: 'black',
  size: 'S',
})`
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const RoadStretchRow = styled.div`
  display: flex;
  align-items: center;
  /* Pegados, igual que en la ficha del recorrido: son un solo dato leído de
     corrido, no dos columnas. Separarlos ensanchaba la caja sin aportar nada. */
  gap: 0.6rem;
  /* Los mismos que la caja de un input deshabilitado. */
  height: ${({ theme }) => theme.sizes.buttonHeight};
  padding: 0 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background-color: ${({ theme }) => theme.colors.greyLight};
`;

export const RoadStretchName = styled.span`
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.S};
  white-space: nowrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const RoadStretchRange = styled.span`
  font-size: ${({ theme }) => theme.fontSize.S};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;
